import React from "react";
import {
  useNavigate
} from "react-router-dom";
import { confirmedDelayMinutes, displayStatus } from "../delay";


const TrainRow = ({ train }) => {
  const navigate = useNavigate();

  const getStatusClass = () => {
    const delayMinutes = confirmedDelayMinutes(train);
    const isOnTime = displayStatus(train).trim().toLowerCase() === "on time";
    if (isOnTime) return "";
    if (train.holding || delayMinutes > 10) return "redbg";
    if (delayMinutes > 4) return "yellowbg";
    return "";
  };
  
  const handleRowClick = () => {
    navigate(`/${train.trainId}`);
  };
  return (
    <tr onClick={handleRowClick}
      className="clickable-row"
      style={{ cursor: "pointer" }}
    >
      <td>{train.trainId}</td>
      <td className={getStatusClass()}>{displayStatus(train)}</td>
      <td>{train.canceled ? "" : train.location}</td>
    </tr>
  );
};


const TrainRowMobile = ({ train }) => {
  const navigate = useNavigate();
    const handleRowClick = () => {
      navigate(`/${train.trainId}`);
    };
  // const getStatusClass = () => {
  //   if (train.holding || train.minutesLate > 10) return "red";
  //   if (train.minutesLate > 4) return "yellow";
  //   return "green";
  // };

  return (
    <tr onClick={handleRowClick}
      className="clickable-row {getStatusClass()}"
      style={{ cursor: "pointer" }}
    >
      <td>{train.trainId} - {displayStatus(train)} - {train.canceled ? "" : train.location}</td>
    </tr>
  );
};


// Group and export both components
export {
  TrainRow,
  TrainRowMobile
};
